import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import { Calendar as BigCalendar, Views, dateFnsLocalizer } from 'react-big-calendar';
import index from "../../../api/auth/items/itemBookableDurations/itemAvailabilities";
import create from "../../../api/auth/items/itemBookableDurations/itemAvailabilities/create";
import combineDateTime from "../../../services/combineDateTime";
import destroy from "../../../api/auth/items/itemBookableDurations/itemAvailabilities/destroy";
import WushTextField from "../WushTextField";

const locales = {
	"en-US": require("date-fns")
};

const localizer = dateFnsLocalizer({
	format,
	parse,
	startOfWeek,
	getDay,
	locales
});

export default function ItemAvailabilitiesForm({ itemBookableDuration }) {
  const [ itemAvailabilities, setItemAvailabilities ] = useState([]);
  const [ quantityAvailable, setQuantityAvailable ] = useState(0);

  useEffect(() => {
    index(itemBookableDuration.item_id, itemBookableDuration.id, (response) => {
      setItemAvailabilities(response);
      setQuantityAvailable(response[0]?.quantity);
    });
  }, [itemBookableDuration]);

  const handleDateSelect = (startDate) => {
    const startAt = combineDateTime(new Date(startDate), new Date(itemBookableDuration?.bookable_duration?.start_time));
    const endAt = combineDateTime(new Date(startDate), new Date(itemBookableDuration?.bookable_duration?.end_time));
    const body = {
      start_at: startAt,
      end_at: endAt,
      available: !itemBookableDuration.default_available,
      quantity: quantityAvailable
    };
    create(itemBookableDuration.item_id, itemBookableDuration.id, body, (response) => {
      setItemAvailabilities([ ...itemAvailabilities, response ]);
    });
  };

  const handleRemoveAvailability = (itemAvailability) => {
    destroy(itemBookableDuration.item_id, itemBookableDuration.id, itemAvailability.id, () => {
      setItemAvailabilities(itemAvailabilities.filter((availability) => availability.id !== itemAvailability.id));
    }, (error) => {
      console.log(error);
    });
  };

  console.log(quantityAvailable);

  return (
    <Stack>
      <Stack>
        <Typography variant="h6">Select {itemBookableDuration.default_available ? "Blackouts" : "Availabilities"}</Typography>
      </Stack>
      <Stack mb={2}>
        <WushTextField
          formRegistration={{ onChange: (event) => setQuantityAvailable(parseInt(event.target.value, 10)) }}
          label="Quantity Available"
          value={quantityAvailable || 0}
        />
      </Stack>
      <BigCalendar
        views={[Views.MONTH]}
        events={itemAvailabilities}
        startAccessor={(itemAvailability) => new Date(itemAvailability.start_at)}
        endAccessor={(itemAvailability) => new Date(itemAvailability.end_at)}
        localizer={localizer}
        titleAccessor={(itemAvailability) => <Typography>{itemAvailability.available ? "Avail." : "N/A"}.</Typography>}
        onSelectSlot={({ start }) => handleDateSelect(start)}
        onSelectEvent={(event) => handleRemoveAvailability(event)}
        style={{ height: '35vh' }}
        selectable
      />
    </Stack>
  );
}